module.exports = __webpack_public_path__ + "img/avator.38be20ad.png";